export const permissions = {
    1: 'FOUNDER',
    2: 'ADMINISTRATOR',
    4: 'MANAGE_CAMPAIGN',
    8: 'FINANCE',
    16: 'REPORT',
    32: 'EMAIL',
    // TODO: Add the rest here.
};

export const calculatePermissions = (bitfield) => {
    const userPermissions = [];

    if (bitfield & 1) return Object.values(permissions);
    if (bitfield & 2) {
        const adminPermissions = Object.values(permissions).filter(perm => perm !== 'FOUNDER');
        return adminPermissions;
    }

    for (const bit in permissions) {
        if (bitfield & bit) {
            userPermissions.push(permissions[bit]);
        }
    }

    // console.log('userPermissions', userPermissions);
    // console.log('bitfield', bitfield);

    return userPermissions;
};
